<div class="row">
  <div class="col-sm-12">
    <div class="card p-2 h-100 text-center">
      <div class="row">
        <div class="col-2">
        </div>
        <div class="mt-3" style="margin:auto;">
          <kendo-buttongroup [selection]="'single'">
            <button *ngFor="let filter of taskFilters;" kendoButton (click)="taskFilterSelected(filter.value)"
              [selected]="filter.value === selectedTaskFilter" [toggleable]="true" class="mr-2 custom-state-button">
              {{filter.text}}
            </button>
          </kendo-buttongroup>
        </div>
        <div class="row mt-3 mb-3" style="padding-left:12px;">
          <div class="col-2 flex-center">
            <i class="far fa-check-square fa-2x" title="{{ 'TASKS' | translate }}"></i>
          </div>
          <div class="col-10 pl-1" style="padding-right:50px">
            <kendo-grid #grid [data]="gridView" [navigable]="true"
              [pageable]="count > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="state.take"
              [skip]="state.skip" [loading]="loading" [sort]="state.sort" [filter]="state.filter" [sortable]="true"
              [filterable]="false" [columnMenu]="false" [resizable]="true" [reorderable]="false"
              (dataStateChange)="dataStateChange($event)" [selectable]="{ mode: 'single' }" [rowClass]="rowCallback">
              <kendo-grid-messages noRecords="{{ 'NO-TASKS' | translate }}">
              </kendo-grid-messages>
              <kendo-grid-column field="name" title="{{ 'TASK' | translate }}" class="emphasizedLabel" [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="ellipsis-text">
                    <a class="pointer" (click)="openTask(dataItem)" title="{{ dataItem.name }}">
                      <strong [ngClass]="{'completed-task': dataItem.status === 'Completed'}">{{ dataItem.name
                        }}</strong>
                    </a>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="assigneeName" title="{{'ASSIGNED-TO' | translate}}" [width]="90">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.assigneeName}}
                  <a *ngIf="dataItem.status === 'Open'" class="pointer float-right" title="{{'REASSIGN' | translate}}"
                    (click)="openTaskAssigneeDialog(dataItem)">
                    <i class="fas fa-undo icon-info"></i>
                  </a>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="dueDate" title="{{ 'DUE-ON' | translate }}" [width]="80">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="text-capitalize"
                    title="{{intl.formatDate(intl.parseDate(dataItem.dueDate), 'd')}}">{{dataItem.nextTaskDueDateText}}</span>
                  <a *ngIf="dataItem.status === 'Open'" class="pointer float-right" title="{{'EDIT' | translate}}"
                    (click)="openTaskDueDateDialog(dataItem);">
                    <i class="fas fa-undo icon-info"></i>
                  </a>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="priority" title="{{ 'PRIORITY' | translate }}" [width]="49" class="text-center"
                [columnMenu]="false">
                <ng-template kendoGridFilterCellTemplate let-filter>
                  <app-dropdown-filter [filter]="filter" [data]="distinctPriorities" filterField="priority"
                    selectDefaultText="{{ 'SELECT-PRIORITY' | translate }}" textField="priorityName"
                    valueField="priority">
                  </app-dropdown-filter>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div [className]="dataItem.priorityBadgeClass">{{ dataItem.priority.charAt(0) }}</div>
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- task assignment dialog -->
<app-task-assign [task]="task" [dialogOpened]="assigneeDialogOpened" (closing)="closeTaskAssigneeDialog();"
  (save)="updateTaskAssignee($event)">
</app-task-assign>

<!-- duedate task dialog -->
<app-task-duedate [task]="task" [dialogOpened]="taskDueDateOpened" (closing)="closeTaskDueDateDialog()"
  (save)="updateTaskDueDate($event)">
</app-task-duedate>

<!-- Task detail dialog -->
<div class="k-overlay" *ngIf="taskOpened"></div>
<kendo-window id="task-detail" [width]="getDialogTaskDetailsWidth()" [height]="590" *ngIf="taskOpened"
  (close)="closeTaskDialog()" style="position:fixed" [top]="60" [state]="windowState">
  <kendo-window-titlebar>
    <div class="k-window-title">
      <h3 class="ellipsis-text">{{task.name}}</h3>
    </div>
    <button kendoWindowMaximizeAction></button>
    <button kendoWindowRestoreAction></button>
    <button kendoWindowCloseAction></button>
  </kendo-window-titlebar>
  <app-task-detail [task]="task" (completed)="onTaskCompleted()" (followUpTaskAddedEvent)="getTasks()"
    (dueDateUpdated)="dueDateUpdated($event)" [isDialog]="true">
  </app-task-detail>
  <kendo-dialog-actions style="position:absolute;margin-left:-16px" class="w-100 mt-3">
    <button kendoButton [primary]="true" type="button" (click)="closeTaskDialog()">
      {{ 'CLOSE' | translate}}</button>
  </kendo-dialog-actions>
</kendo-window>